<h1 mat-dialog-title>Prompt</h1>
<div mat-dialog-content>
    <p>Enter the prompt for your article. Keep it specific to the topic at hand without specifics about things like slide count.</p>
    <p class="example"><span class="bold">Example:</span> The Best NFL Quarterbacks of All Time</p>
</div>
<mat-form-field>
    <mat-label>Prompt</mat-label>
    <input matInput [(ngModel)]="prompt">
</mat-form-field>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-button [mat-dialog-close]="prompt" cdkFocusInitial>Continue</button>
</div>